import { render, staticRenderFns } from "./personnelOverview_listItemActivity.vue?vue&type=template&id=4887271e&scoped=true&"
import script from "./personnelOverview_listItemActivity.vue?vue&type=script&lang=js&"
export * from "./personnelOverview_listItemActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4887271e",
  null
  
)

export default component.exports